import script from "./bi-tmpl-detail-20.vue?vue&type=script&lang=ts&setup=true"
export * from "./bi-tmpl-detail-20.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__